import React, { createContext, useContext } from 'react'
import type {
  NotificationApiAdapter,
  NotificationTypeRegistry,
  NotificationResponse,
} from './types'

interface NotificationContextValue {
  adapter: NotificationApiAdapter
  typeRegistry: NotificationTypeRegistry
}

const NotificationContext = createContext<NotificationContextValue | null>(null)

export function useNotificationContext(): NotificationContextValue | null {
  return useContext(NotificationContext)
}

/** No-op adapter for apps that don't have a notifications backend yet. */
export const noopNotificationAdapter: NotificationApiAdapter = {
  async getNotifications() {
    const empty: NotificationResponse = {
      data: [],
      pagination: { page: 1, limit: 20, total: 0, totalPages: 0, hasNext: false, hasPrev: false },
    }
    return empty
  },
  async getUnreadCount() {
    return 0
  },
  async markAsRead() {},
  async markAsUnread() {},
  async markAllAsRead() {
    return { markedCount: 0 }
  },
  async deleteNotification() {},
  async bulkMarkAsRead() {},
  async bulkMarkAsUnread() {},
  async bulkDelete() {},
}

interface NotificationProviderProps {
  adapter: NotificationApiAdapter
  typeRegistry: NotificationTypeRegistry
  children: React.ReactNode
}

export function NotificationProvider({ adapter, typeRegistry, children }: NotificationProviderProps) {
  return (
    <NotificationContext.Provider value={{ adapter, typeRegistry }}>
      {children}
    </NotificationContext.Provider>
  )
}
